/**
 * @generated SignedSource<<842776db5f06b857cfac39455657efec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type quoteRuleEditor_ProductNameQuery$variables = {
  id: string;
};
export type quoteRuleEditor_ProductNameQuery$data = {
  readonly node: {
    readonly name?: string;
  } | null;
};
export type quoteRuleEditor_ProductNameQuery = {
  response: quoteRuleEditor_ProductNameQuery$data;
  variables: quoteRuleEditor_ProductNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Model",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "quoteRuleEditor_ProductNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "quoteRuleEditor_ProductNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31df39fb5b6d83175b23fdcb3997a086",
    "id": null,
    "metadata": {},
    "name": "quoteRuleEditor_ProductNameQuery",
    "operationKind": "query",
    "text": "query quoteRuleEditor_ProductNameQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Model {\n      name\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4cb0ad3d1da612c1958069944d054f3";

export default node;
